window.addEventListener('DOMContentLoaded', function () {
	window.addEventListener('load', function () {
		var dobField = document.getElementById('customer-dob');
		if (dobField) {
			dobField.addEventListener('input', function () {
				var dobValue = this.value;
				var noteField = document.getElementById('customer-note');

				if (noteField) {
					if (dobValue) {
						// Parse MM/DD/YYYY and convert to YYYY-MM-DD
						var parts = dobValue.split('/');
						if (parts.length === 3) {
							var month = parts[0].padStart(2, '0');
							var day = parts[1].padStart(2, '0');
							var year = parts[2];
							noteField.value = 'DOB: ' + year + '-' + month + '-' + day;
						} else {
							// If not in expected format, just store as-is with prefix
							noteField.value = 'DOB: ' + dobValue;
						}
					} else {
						noteField.value = '';
						tagField.value = '';
					}
				}
			});
		}

		// header
		var stickyCollectionsNav = document.querySelector('#collection-nav');
		var header = document.querySelector('header.nav-header');
		if (stickyCollectionsNav && header) {
			const stickyOffset = stickyCollectionsNav.offsetTop;

			window.addEventListener('scroll', () => {
				if (window.scrollY >= stickyOffset) {
					stickyCollectionsNav.classList.add('is-stuck');
				} else {
					stickyCollectionsNav.classList.remove('is-stuck');
				}
			});

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.attributeName === 'class') {
						var oldClass = mutation.oldValue;
						var newClass = header.className;
						if (newClass.includes('scroll-down-withoutAnnouncement')) {
							stickyCollectionsNav.style.top = header.offsetHeight + 'px';
						} else {
							stickyCollectionsNav.style.top = '0px';
						}
					}
				});
			});

			observer.observe(header, {
				attributes: true,
				attributeOldValue: true,
				attributeFilter: ['class'],
			});
		}
	});
});
